import api from './api';

const authService = {
  // Register new user
  register: async (userData) => {
    const response = await api.post('/api/auth/register', {
      name: userData.name,
      email: userData.email,
      password: userData.password,
      phone: userData.phone,
      role: userData.role || 'hunter',
      acceptTerms: userData.acceptTerms,
    });
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('refreshToken', response.data.refreshToken);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // Login
  login: async (email, password) => {
    const response = await api.post('/api/auth/login', { email, password });

    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('refreshToken', response.data.refreshToken);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }

    return response.data;
  },

  // Logout
  logout: () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) api.post('/api/auth/logout', { refreshToken }).catch(() => {});
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
  },

  // Get current user
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');
  },
  getAuthenticatedUser: async () => {
    const user = (await api.get('/api/auth/me')).data.user;
    localStorage.setItem('user', JSON.stringify(user));
    return user;
  },
  getUserStats: async () => (await api.get('/api/users/me/stats')).data.data,
  updateProfile: async (data) => (await api.patch('/api/users/me', data)).data.data,
  updateSettings: async (settings) => (await api.patch('/api/users/me', { settings, language: settings.language })).data.data,
  changePassword: async (currentPassword, newPassword) => (
    await api.post('/api/auth/change-password', { currentPassword, newPassword })
  ).data,
  uploadAvatar: async (formData) => (await api.post('/api/users/me/avatar', formData, { headers: { 'Content-Type': 'multipart/form-data' } })).data.data,
  deleteAccount: async () => api.delete('/api/users/me'),
  forgotPassword: async (email) => (await api.post('/api/auth/forgot-password', { email })).data,
  resetPassword: async (token, password) => (await api.post('/api/auth/reset-password', { token, password })).data,
};

export default authService;
